// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorDistributors = (client) => ({
    /**
     * `POST /vendor/distributors`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorsCreate
     * @source apps/backend/src/api/vendor/distributors/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/distributors", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/distributors/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorsIdDelete
     * @source apps/backend/src/api/vendor/distributors/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/distributors/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/distributors`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorsList
     * @source apps/backend/src/api/vendor/distributors/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/distributors", { method: "GET", query, headers }),
    /**
     * `GET /vendor/distributors/search`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorsSearchRetrieve
     * @source apps/backend/src/api/vendor/distributors/search/route.ts
     */
    search: (query, headers) => client.fetch("/vendor/distributors/search", { method: "GET", query, headers }),
    /**
     * `PUT /vendor/distributors/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorsIdPut
     * @source apps/backend/src/api/vendor/distributors/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/distributors/:id", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=distributors.js.map